(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/article/assets/article-actions.js') >= 0) return;  svs.modules.push('/components/tipsen/article/assets/article-actions.js');
"use strict";

const loadArticle = svs.content.simple_article.contentLoader.loadArticle;
const ContentUrlBuilder = svs.content.shared.ContentUrlBuilder;
const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk;
const fetchArticle = createAsyncThunk('tipsen/fetchArticle', (_ref, _ref2) => {
  let articleId = _ref.articleId,
    _ref$forceFetch = _ref.forceFetch,
    forceFetch = _ref$forceFetch === void 0 ? false : _ref$forceFetch;
  let getState = _ref2.getState;
  if (!articleId) {
    throw new Error('Missing argument. articleId required');
  }
  const state = getState();
  const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
  if (useLegacyJupiterApi) {
    const options = {
      url: new ContentUrlBuilder("/content/2/id/".concat(articleId)).build()
    };
    return new Promise((resolve, reject) => {
      const article = !forceFetch ? state.Articles[articleId].article : undefined;
      if (article) {
        resolve(article);
        return;
      }
      loadArticle(options, (err, article) => {
        if (err) {
          reject(err);
          return;
        }
        resolve(article);
      });
    });
  }
  const article = !forceFetch ? state.Articles[articleId].article : undefined;
  if (article) {
    return article;
  }
  const client = svs.content.shared.getCmsClient();
  return client.v1.content.getById(articleId);
});
setGlobal('svs.components.tipsen.article.actions', {
  fetchArticle
});

 })(window);